/// <reference path="../../activityfeed/models/bindable.ts" />
/// <reference path="../../../../Scripts/typings/toastr/toastr.d.ts" />
/// <reference path="../../../../Scripts/typings/knockout.es5/knockout.es5.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/clientteam/viewmodels/index',["require", "exports", "common/viewmodelbase", "services/navigator", "areas/clientteam/models/bindable", "areas/clientteam/parts/getclientteammembers"], function (require, exports, common, navigator, BindableModel, GetClientTeamMembers) {
    "use strict";
    var NewsViewModel = (function (_super) {
        __extends(NewsViewModel, _super);
        function NewsViewModel() {
            _super.call(this);
            this.getclientteammembers = new GetClientTeamMembers();
            this.newVersion = false;
            this.members = new Array();
            this.title = "News";
            ko.track(this, ["members", "newVersion"]);
        }
        NewsViewModel.prototype.onActivated = function (context) {
            this.getClientTeamMembers();
        };
        NewsViewModel.prototype.showFullNewsList = function () {
            navigator.navigateTo("account", "news", "news");
        };
        NewsViewModel.prototype.showLegalNotice = function () {
            navigator.navigateTo("account", "legalnotice", "legalnotice");
        };
        NewsViewModel.prototype.showPrivacyStatement = function () {
            navigator.navigateTo("account", "privacystatement", "privacystatement");
        };
        NewsViewModel.prototype.getClientTeamMembers = function () {
            var _this = this;
            return this.getclientteammembers.get()
                .then(function (response) {
                if (response != null) {
                    if (response.length > 0 && response[0].isOneClickActivated)
                        _this.newVersion = true;
                    for (var i = 0; i < response.length; i++) {
                        var member = new BindableModel.Members();
                        if (response[i].imageUri != "") {
                            member.logo = response[i].imageUri;
                        }
                        else {
                            member.logo = '/html/content/images/employee-icon.png';
                        }
                        member.name = response[i].fName + " " + response[i].lName;
                        member.memberType = response[i].role;
                        member.roleSelected = response[i].roleSelected;
                        member.hideRole = response[i].hideRole;
                        _this.members.push(member);
                    }
                }
            });
        };
        return NewsViewModel;
    }(common.ViewModelBase));
    return NewsViewModel;
});

